import React from "react";
import moment from "moment";
import { Breadcrumb, Panel } from "react-bootstrap";
import PanelBody from "react-bootstrap/lib/PanelBody";
import PanelHeading from "react-bootstrap/lib/PanelHeading";
import PanelTitle from "react-bootstrap/lib/PanelTitle";
import { LinkContainer } from "react-router-bootstrap";
import { useEventContext } from "../../../../context";
import locale from "../../../../locale";
import GeneralSettings from "./GeneralSettings";
import StreamsSettings from "./StreamsSettings";
import { NotificationProvider } from "../../../UI/Notifications";

const DATE_FORMAT = 'YYYY-MM-DD HH:mm:ss';

const CommonSettings = ({ }) => {
    const { event, setEvent } = useEventContext();

    return (
        <section>
            <Breadcrumb>
                <LinkContainer to={`/event/${event.eventPassword}`}>
                    <Breadcrumb.Item>{locale('mainMenu.eventSettings')}</Breadcrumb.Item>
                </LinkContainer>
                <Breadcrumb.Item active>{locale('mainMenu.eventSettings.commonSettings')}</Breadcrumb.Item>
            </Breadcrumb>

            <h3>{event.name_ru}</h3>
            <p>{moment.unix(event.timeStart).format(DATE_FORMAT)} - {moment.unix(event.timeStop).format(DATE_FORMAT)}</p>

            <div style={{ display: 'flex', gap: '2rem' }}>

                <Panel style={{ flex: 1 }}>
                    <PanelHeading>
                        <PanelTitle>Общие настройки</PanelTitle>
                    </PanelHeading>
                    <PanelBody>
                        <NotificationProvider>
                            <GeneralSettings event={event} setEvent={setEvent} />
                        </NotificationProvider>
                    </PanelBody>
                </Panel>
                <Panel style={{ flex: 1 }}>
                    <PanelHeading>
                        <PanelTitle>Залы</PanelTitle>
                    </PanelHeading>
                    <PanelBody>
                        <StreamsSettings event={event} setEvent={setEvent} />
                    </PanelBody>
                </Panel>
                <div style={{ flex: 1 }}></div>
            </div>
        </section>
    );
};

export default CommonSettings;